import { AutocompleteInput, AutocompleteInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';

export const GrayAutocompleteInputWithUpperLabel = (props: AutocompleteInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <AutocompleteInput
        {...props}
        label={false}
        componentsProps={{
          ...props.componentsProps,
          paper: {
            ...props.componentsProps?.paper,
            sx: {
              boxShadow: '0 2px 8px 4px lightgray',
              ...props.componentsProps?.paper?.sx,
            },
          },
        }}
        sx={{
          '& fieldset': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f1f1f1 !important',
          },
          ...props.sx,
        }}
      />
    </Box>
  );

};
